module.exports = __webpack_public_path__ + "static/media/testimonial_2.9f34b85a.jpg";